import { Box, Stack, Typography } from '@mui/material';
import { format } from 'date-fns';
import { Bell01, Clock } from 'untitledui-js-base';
import { Car } from '../types/accident';

const getRentalInfoProps = (type: 'success' | 'red' | 'warning') => {
  switch (type) {
    case 'success':
      return {
        borderColor: '#2e7d32',
        iconColor: '#2e7d32',
        textColor: '#2e7d32',
        icon: Clock,
        text: 'Aktivní půjčovna'
      };
    case 'warning':
      return {
        borderColor: '#ed6c02',
        iconColor: '#ed6c02',
        textColor: '#ed6c02',
        icon: Bell01,
        text: 'Žádost o jakýkoliv vůz'
      };
    case 'red':
    default:
      return {
        borderColor: '#d32f2f',
        iconColor: '#d32f2f',
        textColor: '#d32f2f',
        icon: Bell01,
        text: 'Naplánovaná blokace'
      };
  }
};

const getDateLabel = (
  type: 'success' | 'red' | 'warning',
  rentalDate?: Date,
  returnDate?: Date,
  createdDate?: Date
) => {
  const formatDate = (d?: Date) => (d ? format(d, 'd.M.yyyy') : '');

  switch (type) {
    case 'red':
      return rentalDate && returnDate ? `Termín blokace: ${formatDate(rentalDate)} – ${formatDate(returnDate)}` : null;

    case 'success':
      return rentalDate && returnDate
        ? `Termín: ${formatDate(rentalDate)} – ${formatDate(returnDate)}`
        : rentalDate
          ? `Termín: ${formatDate(rentalDate)}`
          : null;

    case 'warning':
      return createdDate && rentalDate
        ? `Žádáno dne: ${formatDate(createdDate)}   Termín: ${formatDate(rentalDate)}`
        : createdDate
          ? `Žádáno dne: ${formatDate(createdDate)}`
          : null;

    default:
      return null;
  }
};

interface RentalInfoBoxProps {
  type: 'success' | 'red' | 'warning';
  name?: string;
  carInfo?: Car;
  reservationDate?: Date;
  requestDate?: Date;
  rentalDate?: Date;
  returnDate?: Date;
  onClick?: () => void;
}

export const RentalInfoBox = ({
  carInfo,
  type,
  name,
  reservationDate,
  requestDate,
  returnDate,
  rentalDate,
  onClick
}: RentalInfoBoxProps) => {
  const { borderColor, iconColor, textColor, icon: Icon, text } = getRentalInfoProps(type);
  const dateLabel = getDateLabel(type, rentalDate, returnDate, requestDate);

  return (
    <Box onClick={onClick} sx={{ cursor: 'pointer' }}>
      {name && (
        <Typography sx={{ color: textColor }} fontWeight="700" component="span" fontSize="0.6rem">
          {name}
        </Typography>
      )}
      <Stack
        sx={{
          border: '1px solid',
          borderColor,
          borderRadius: 2,
          paddingX: '15px',
          paddingY: '8px'
        }}
      >
        <Stack direction="row" gap={1} alignItems="center">
          <Icon color={iconColor} size="1.2rem" />
          <Stack>
            <Typography fontWeight="700" fontSize="12px" sx={{ color: textColor }}>
              {`${text} ${carInfo && [carInfo.brand, carInfo.model, carInfo.plateNumber].filter(Boolean).join(' ')}`}
            </Typography>
            {dateLabel && <Typography fontSize="12px">{dateLabel}</Typography>}
            {reservationDate && (
              <Typography fontSize="12px">
                {`Expirace blokace: ${format(reservationDate, 'dd.MM.yyyy HH:mm')}`}
              </Typography>
            )}
          </Stack>
        </Stack>
      </Stack>
    </Box>
  );
};
